import React, { useState, useEffect } from 'react';
import './index.scss';
import { apis, apiHolder as api, inWindow } from 'api';
import ThumbUpModal from '../ThumbUpModal';
import NoticeModal from './NoticeModal';
import message from '@web-common/components/UI/Message/SiriusMessage';
import { getIn18Text } from 'api';
const trackApi = api.api.requireLogicalApi(apis.dataTrackerApiImp);
const MailApi = api.api.requireLogicalApi(apis.mailApiImpl);
const ThumbUp = ({ mid, content, emoticonInfo, handleEmoticon }) => {
    const [visible, setVisible] = useState(false);
    const [noticeVisible, setNoticeVisible] = useState(false);
    const [thumbUpNotice, setThumbUpNotice] = useState(!(inWindow() && window.localStorage.getItem('thumbUpNotice')));
    const [thumbUpSend, setThumbUpSend] = useState(inWindow() && window.localStorage.getItem('thumbUpSend') === '1');
    const [showNickNames, setShowNickNames] = useState([]);
    const [hideCount, setHideCount] = useState(0);
    const changeThumbState = () => {
        var _a, _b, _c, _d, _e, _f;
        let params = {
            email_tid: ((_a = content === null || content === void 0 ? void 0 : content.entry) === null || _a === void 0 ? void 0 : _a.tid) || '',
            email_mid: content.id,
            type: 1,
            participated: !(emoticonInfo === null || emoticonInfo === void 0 ? void 0 : emoticonInfo.participated),
            email_title: (_b = content === null || content === void 0 ? void 0 : content.entry) === null || _b === void 0 ? void 0 : _b.title,
            sender_email: (_e = (_d = (_c = content === null || content === void 0 ? void 0 : content.sender) === null || _c === void 0 ? void 0 : _c.contact) === null || _d === void 0 ? void 0 : _d.contact) === null || _e === void 0 ? void 0 : _e.accountName,
            sender_mid: (_f = content === null || content === void 0 ? void 0 : content.entry) === null || _f === void 0 ? void 0 : _f.sentMailId,
            _account: content === null || content === void 0 ? void 0 : content._account,
        };
        !(emoticonInfo === null || emoticonInfo === void 0 ? void 0 : emoticonInfo.participated) ? trackApi.track('pcMail_click_likeMail') : trackApi.track('pcMail_click_cancelLikeMail');
        MailApi.setThumbUpCreate(params).then(data => {
            handleEmoticon(data, params.email_mid);
            if (data && !data.sender_is_internal && (data === null || data === void 0 ? void 0 : data.participated) && (data === null || data === void 0 ? void 0 : data.first_participated)) {
                if (thumbUpNotice) {
                    setNoticeVisible(true);
                }
                if (thumbUpSend && emoticonInfo.first_participated) {
                    replyMail();
                }
            }
        });
    };
    const replyMail = async () => {
        const { errMsg } = await MailApi.replyExternalThumbMail(mid, false, true);
        if (errMsg) {
            return;
        }
        message.success({
            content: getIn18Text('DIANZANYOUJIANYI'),
        });
    };
    const setInfoModal = () => {
        trackApi.track('pcMail_click_likeMailDetail');
        setVisible(true);
    };
    const closeSendMailModal = (isNotice, isSend) => {
        setNoticeVisible(false);
        if (isNotice) {
            setThumbUpNotice(false);
            inWindow() && window.localStorage.setItem('thumbUpNotice', '1');
            setThumbUpSend(isSend);
            inWindow() && window.localStorage.setItem('thumbUpSend', isSend ? '1' : '0');
        }
        if (isSend) {
            replyMail();
        }
    };
    const getTextWidth = (fontSize, fontFamily, text) => {
        var span = document.createElement('span');
        var result = { width: 0 };
        result.width = span.offsetWidth;
        span.style.visibility = 'hidden';
        span.style.fontSize = fontSize;
        span.style.fontFamily = fontFamily;
        span.style.fontStyle = 'normal';
        span.style.display = 'inline-block';
        document.body.appendChild(span);
        if (typeof span.textContent != 'undefined') {
            span.textContent = text;
        }
        else {
            span.innerText = text;
        }
        result.width = parseInt(window.getComputedStyle(span).width) - result.width;
        span.remove();
        return result;
    };
    const renderNames = (showNickNames) => {
        return (React.createElement(React.Fragment, null, showNickNames &&
            showNickNames.map((record, i, arr) => {
                if (arr.length - 1 === i) {
                    return React.createElement("span", { key: record.acc_id }, record.nick_name_slice || record.nick_name || record.acc_email);
                }
                else {
                    return (React.createElement(React.Fragment, null,
                        React.createElement("span", { key: record.acc_id }, record.nick_name_slice || record.nick_name || record.acc_email),
                        " ",
                        React.createElement("span", null, "\u3001")));
                }
            })));
    };
    useEffect(() => {
        var _a;
        if ((emoticonInfo === null || emoticonInfo === void 0 ? void 0 : emoticonInfo.involvedRecords) && (emoticonInfo === null || emoticonInfo === void 0 ? void 0 : emoticonInfo.involvedRecords.length) > 0) {
            let personWidth = 0;
            if (document.querySelector('.u-read-wrapper')) {
                personWidth = (_a = document.querySelector('.u-read-wrapper')) === null || _a === void 0 ? void 0 : _a.clientWidth;
                personWidth = personWidth - 16 * 4;
            }
            let showNames = [];
            let totalWidth = 0;
            emoticonInfo === null || emoticonInfo === void 0 ? void 0 : emoticonInfo.involvedRecords.map((record, i) => {
                if (record.nick_name.length > 10) {
                    record.nick_name_slice = record.nick_name.slice(0, 10) + '...';
                }
                const textAttr = getTextWidth('12px', 'PingFang SC', record.nick_name_slice || record.nick_name || record.acc_email);
                totalWidth = totalWidth + textAttr.width + 12 + 3;
                if (totalWidth < personWidth - 100) {
                    showNames.push(record);
                }
            });
            setShowNickNames(showNames);
            setHideCount(emoticonInfo.count - showNames.length);
        }
    }, [emoticonInfo]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "thumb-up" },
            React.createElement("div", { className: "thumb-up-icon", onClick: e => {
                    e.stopPropagation();
                    changeThumbState();
                } }),
            React.createElement("div", { className: "thumb-up-person", onClick: e => {
                    e.stopPropagation();
                    setInfoModal();
                } }, React.createElement(React.Fragment, null,
                React.createElement("span", null, renderNames(showNickNames)),
                React.createElement("span", { className: "thumb-up-person-more", hidden: hideCount === 0 },
                    "+",
                    hideCount,
                    getIn18Text('REN'))))),
        visible ? (React.createElement(ThumbUpModal, { onClose: () => setVisible(false), visible: visible, content: content, involvedRecords: (emoticonInfo === null || emoticonInfo === void 0 ? void 0 : emoticonInfo.involvedRecords) || [], count: emoticonInfo.count })) : null,
        noticeVisible ? React.createElement(NoticeModal, { visible: noticeVisible, onClose: (isNotice, isSend) => closeSendMailModal(isNotice, isSend) }) : null));
};
export default ThumbUp;
